// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/welcome_card.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome_left {
    position: relative;
    width: 100%;
    height: 100%;
}

.welcome_image {
    position: absolute;
    max-width: 100%;
    max-height: 115%;
    left: 10px;
    bottom: 0;
}
.welcome_right {
    padding: 32px 23px 27px 10px;
}
.progress_text {
    width: 100%;
    padding-bottom: 10px;
    text-align: center;
}
.progress_text > h2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    color: #ffffff;
}
.progress_text > p {
    font-size: 12px;
    max-width: 260px;
    font-weight: 300;
    color: rgba(255,255,255,0.66);
    margin-bottom: 10px;
}

.welcome_circle {
    width: 150px;
    height: 150px;
}

@media (max-width: 600px) {
    .progress_text > h2 {
        text-align: left;
    }
}
.welcome_dash {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: 140% 140%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    position: relative;
}

@media (max-width: 1100px) {
    .welcome_dash {
        grid-template-columns: 1fr;
    }
}


.welcome_dash_text {
    font-size: 14px;
    color: rgba(255,255,255,0.66);
}

@media (max-width: 1330px) {
    .welcome_circle {
        padding-top: 10px;
    }
}

@media (max-width: 1050px) {
    .welcome_dash {
        width: 100%;
        height: 100%;
    }
}

@media (max-width: 850px) {
    .welcome_dash {
        margin-bottom: 40px;
    }
}
@media (max-width: 500px) {
    .welcome_circle {
        max-width: 75%;
    }
    .progress_text {
        padding-top: 7px;
        width: 75%;
        margin-left: 10px;
        margin-right: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/DashboardCharts/ProfileCompletion.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,yDAAmD;IACnD,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;AACJ","sourcesContent":[".welcome_left {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.welcome_image {\n    position: absolute;\n    max-width: 100%;\n    max-height: 115%;\n    left: 10px;\n    bottom: 0;\n}\n.welcome_right {\n    padding: 32px 23px 27px 10px;\n}\n.progress_text {\n    width: 100%;\n    padding-bottom: 10px;\n    text-align: center;\n}\n.progress_text > h2 {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 25px;\n    color: #ffffff;\n}\n.progress_text > p {\n    font-size: 12px;\n    max-width: 260px;\n    font-weight: 300;\n    color: rgba(255,255,255,0.66);\n    margin-bottom: 10px;\n}\n\n.welcome_circle {\n    width: 150px;\n    height: 150px;\n}\n\n@media (max-width: 600px) {\n    .progress_text > h2 {\n        text-align: left;\n    }\n}\n.welcome_dash {\n    background-image: url(\"../../img/welcome_card.png\");\n    background-position: center;\n    background-size: 140% 140%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    position: relative;\n}\n\n@media (max-width: 1100px) {\n    .welcome_dash {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n.welcome_dash_text {\n    font-size: 14px;\n    color: rgba(255,255,255,0.66);\n}\n\n@media (max-width: 1330px) {\n    .welcome_circle {\n        padding-top: 10px;\n    }\n}\n\n@media (max-width: 1050px) {\n    .welcome_dash {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media (max-width: 850px) {\n    .welcome_dash {\n        margin-bottom: 40px;\n    }\n}\n@media (max-width: 500px) {\n    .welcome_circle {\n        max-width: 75%;\n    }\n    .progress_text {\n        padding-top: 7px;\n        width: 75%;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
